import React, {useEffect, useState} from "react";
import {Table, Tag} from "antd";

const AcceptableMoveTransferTable = ({
    acceptableMoveTransfers,
    acceptableMoveTransfersLoading,
    setSelectedTransfer,
    isModalOpen
}) => {
    const [selectedRowKey, setSelectedRowKey] = useState(null);
    const [tableKey, setTableKey] = useState(0);

    const getStatusTag = status => {
        let text = status;

        switch (status) {
            case "created":
                text = "Oluşturuldu";
                break;
            case "availableForDepot":
                text = "Depoya Hazır";
                break;
            case "inTransit":
                text = "Yolda";
                break;
            case "completed":
                text = "Tamamlandı";
                break;
            case "canceled":
                text = "İptal edildi";
                break;
            case "return":
                text = "İade edildi";
                break;
            case "availableForPickup":
                text = "Yola Çıkmaya Hazır";
                break;
            case "readyToTransfer":
                text = "Transfere Hazır";
                break;
            default:
                text = status;
        }

        return <Tag>{text}</Tag>;
    };

    const columns = [
        {
            title: "İl",
            dataIndex: "city",
            key: "city"
        },
        {
            title: "İlçe",
            dataIndex: "district",
            key: "district"
        },
        {
            title: "Durum",
            dataIndex: "status",
            key: "status",
            render: status => getStatusTag(status)
        },
        {
            title: "Kurye",
            dataIndex: "courier",
            key: "courier",
            render: courier =>
                courier === "motor 1" ? "Motor 1" : courier === "car 1" ? "Araç 1" : courier
        },
        {
            title: "Sevkiyat Sayısı",
            dataIndex: "shipmentCount",
            key: "shipmentCount"
        },
        {
            title: "Paket Sayısı",
            dataIndex: "packageCount",
            key: "packageCount"
        },
        {
            title: "Okutulan Paket Sayısı",
            dataIndex: "scannedCount",
            key: "scannedCount"
        }
    ];

    const rowSelection = {
        selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
        onChange: (selectedKeys, selectedRows) => {
            if (selectedKeys.length > 0 && selectedKeys[0] === selectedRowKey) {
                setSelectedRowKey(null);
                setSelectedTransfer && setSelectedTransfer(null);
            } else {
                const selectedKey = selectedKeys[0];
                setSelectedRowKey(selectedKey);

                if (setSelectedTransfer && selectedRows.length > 0) {
                    setSelectedTransfer(selectedRows[0]);
                }
            }
        },
        preserveSelectedRowKeys: false
    };

    useEffect(() => {
        if (!isModalOpen) {
            setSelectedRowKey(null);
            setSelectedTransfer && setSelectedTransfer(null);
            setTableKey(prevKey => prevKey + 1);
        }
    }, [isModalOpen, setSelectedTransfer]);

    return (
        <Table
            key={tableKey}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={acceptableMoveTransfers?.transfers || []}
            loading={acceptableMoveTransfersLoading}
            pagination={{
                pageSize: acceptableMoveTransfers?.pagination?.limit,
                total: acceptableMoveTransfers?.pagination?.total || 0,
                current: acceptableMoveTransfers?.pagination?.page
            }}
            rowKey="_id"
        />
    );
};

export default AcceptableMoveTransferTable;
